import React, {useState} from 'react';
import CustomInput from "../../components/UI/customInput/customInput";
import CustomButton from "../../components/UI/customButton/customButton";
import {useTranslation} from "react-i18next";
import CustomSelect from "../../components/UI/customSelect/customSelect";
import CityTable from "../../components/table/city-table";
import {Post} from "../../apis/api";
import {toast} from "react-toastify";
import {useDispatch, useSelector} from "react-redux";
import {setting} from "../../store/setting/setting.reducer";

const CitySection = () => {
  const {t} = useTranslation();
  const [form, setForm] = useState({})
  const [open, setOpen] = useState(false)

  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const stateList = useSelector((state) => state.setting.province)
  const [editId, setEditId] = useState(null)
  const dispatch = useDispatch()

  const handleForm = ({name, value}) => {
    setForm((prevState) => ({...prevState, [name]: value}))
  }
  const handleSubmit = () => {
    setLoading(true)
    Post(`basic-information/city/${editId ? `update/${editId}` :"store"}` , {...form , "form" : editId ? "update_form" : "store_form"}).then((res) =>{
      toast.success(res.msg)
      setData(res?.details?.data)
      dispatch(setting({city : res?.details?.data?.data}))
      setOpen(false)
    }).catch((error) => {
      toast.error(error.message)
    })
      .finally(() => {
        setLoading(false)
      })
  }
  const handleEdite = (e) => {
    setOpen(true)
    setForm({"fa_name":e["fa_name"] , "en_name":e["en_name"] , "code":e["code"] , "parent_id":e["parent_id"]})
    setEditId(e.id)
  }
  const handleClose = () => {
    setOpen(false)
    setForm({})
    setEditId(null)
  }
  const handleProvince = (id) => {
    return stateList?.find((item => {
      return (
        item.id === id
      )
    }))
  }
  return (
    <div className={"flex flex-col w-full pb-32"}>

      <div onClick={(e) => e.target === e.currentTarget && handleClose()} className={`fixed top-0 right-0 bg-modal h-full w-full z-50 flex justify-center items-center ${open ? "flex" : "hidden"}`}>
        <div className={" bg-white rounded-lg p-5 flex flex-col items-center max-w-[350px]"}>
          <div className={"text-gray-500 text-base"}>
            {t("titleCity")}
          </div>
          <div className={"grid grid-cols-1  mt-5 flex-wrap justify-between gap-5 w-full "}>
          <span className={"w-full"}>
             <CustomInput
               placeHolder={t("cityNameFa")}
               label={t("cityNameFa")}
               name={"fa_name"}
               defaultValue={form["fa_name"]}
               onchange={(e) => handleForm(e)}

             />
          </span>
            <span className={"w-full "}>
             <CustomInput
               placeHolder={t("cityNameEn")}
               label={t("cityNameEn")}
               name={"en_name"}
               defaultValue={form["en_name"]}
               onchange={(e) => handleForm(e)}
             />
          </span>
          </div>
          <div className={"grid grid-cols-1  mt-5 justify-between gap-5 w-full "}>
            <CustomInput
              placeHolder={t("threeCode")}
              label={t("threeCode")}
              name={"code"}
              defaultValue={form["code"]}
              onchange={(e) => handleForm(e)}
            />
            <CustomSelect
              name="parent_id"
              label={t("selectNameProvince")}
              options={stateList}
              defaultValue={handleProvince(form["parent_id"])}
              onchange={(e) => handleForm(e)}
            />
            <CustomButton loading={loading} onClick={handleSubmit} title={t("save")}/>
          </div>
        </div>
      </div>
      <div className={"flex justify-end gap-5 w-full my-container"}>
        <div className={"w-[207px]"}>
          <CustomButton onClick={() => setOpen(true)} title={t("newCity")}/>
        </div>
      </div>
      <div>
        <CityTable defaultValue={data} editItem={(e) => handleEdite(e)}/>
      </div>
    </div>
  );
};

export default CitySection;
